module.exports = __webpack_public_path__ + "static/img/jingluo.8328ce0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jingluo.jpg
// module id = 48dg
// module chunks = 1